<template>
  <div v-if="isLocalEnvironment" class="filter-sort-buttons">
    <button @click="$emit('open-sort-by')" id="sort-by-button" class="button">Sort By</button>
    <button @click="$emit('open-filters')" class="button">Filters</button>
  </div>
</template>

<script>
import FilterBar from "./FilterBar.ts";
export default {
  ...FilterBar,
};
</script>
<style lang="scss">
@import "./FilterBar.scss";
</style>